import Blank from './Blank'
import Basic from './Basic'

export default {
  Blank,
  Basic
}
